import { render, staticRenderFns } from "./ChevronDown.vue?vue&type=template&id=6006a3b2&scoped=true"
import script from "./ChevronDown.vue?vue&type=script&lang=js"
export * from "./ChevronDown.vue?vue&type=script&lang=js"
import style0 from "./ChevronDown.vue?vue&type=style&index=0&id=6006a3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006a3b2",
  null
  
)

export default component.exports